export enum DOCUMENT_ATTACHMENT_CATEGORIES {
	None = 'None',
	XMLOrderRequest = 'XMLOrderRequest',
	PhotoRequest = 'PhotoRequest',
	PDF = 'PDFOrderRequest',
	PDFSSRReport = 'PDFSSRReport',
	FinalReport = 'FinalReport',
	Attachment = 'Attachment',
	JSONOrderRequest = 'JSONOrderRequest',
	VirtualTour = 'VirtualTour'
}

// ToDo: missing explanation
export enum DOCUMENT_RULES_UI_SECTIONS {
	PDFREVIEW = 'PDFREVIEW',
	PHOTOREVIEW = 'PHOTOREVIEW',
	SUBJECT = 'SUBJECT',
	NEIGHBORHOOD = 'NEIGHBORHOOD',
	IMPROVEMENTS = 'IMPROVEMENTS',
	PROJECTANALYSIS = 'PROJECTANALYSIS',
	PROJECTINFORMATION = 'PROJECTINFORMATION',
	UNITDESCRIPTION = 'UNITDESCRIPTION',
	OVERVIEW = 'OVERVIEW',
	COMPS = 'COMPS',
	REVISIONS = 'REVISIONS',
	SALESAPPROACH = 'SALESAPPROACH',
	COSTAPPROACH = 'COSTAPPROACH',
	INCOMEAPPROACH = 'INCOMEAPPROACH',
	RECONCILIATION = 'RECONCILIATION',
	VIRTUALTOUR = 'VIRTUALTOUR',
	ARRIVAL = 'ARRIVAL',
	SITE = 'SITE',
	STRUCTURES = 'STRUCTURES'
}

export enum SCHEMA_TYPE {
	INSPECTION_R = 'InspectionReport:3',
	CV_REVIEW = 'CVReview:1',
	CV_REVIEW_1073 = 'CVReview1073:1',
	CV_REVIEW_1075 = 'CVReview1075:1',
	CV_REVIEW_2055 = 'CVReview2055:1'
}

export enum ORDER_STATE {
	APPROVE = 'Approve',
	REJECT = 'Reject',
	APPROVED = 'Approved',
	REJECTED = 'Rejected',
	RECALLED = 'Recalling',
	INQUALITY = 'UnderReview',
	QUEUED = 'Queued',
	REVISION_RECEIVED = 'RevisionReceived',
	CANCELLED = 'Cancelled',
	REOPEN = 'ReOpen',
	NOTREVIEWED = 'NotReviewed',
	POST_REVISION_RECEIVED = 'PostRevisionReceived'
}

export enum ORDER_ORIGIN {
	MANUAL = 'Manual',
	CMP_ACUITY = 'CmpAcuity'
}

export const ORDER_ACTIONS_MESSAGE = {
	APPROVED: 'ORDER WAS APPROVED SUCCESSFULLY',
	REJECTED: 'ORDER WAS REJECTED SUCCESSFULLY ',
	MISSING_CHK: 'YOU HAVE RULES TO BE CHECKED'
};

export const UISTATE = {
	IS_LOADING: 'isLoading',
	IS_READY: 'isReady'
};

// Time in seconds
export const USER_TIME_ACTIVITY = {
	IDLE: 600,
	TIMEOUT: 120,
	PING: 10
};
